module.exports = __webpack_public_path__ + "static/media/japaneseSurvivors.449d5e1a.png";